import { fromJS, Map as ImmutableMap } from 'immutable';
import { RequestStatus } from '../../Constants';
const defaultState = {
  selectedVideoFileId: undefined,
  updateSubtitlesRequestStatus: RequestStatus.UNINITIALIZED,
  fetchSubtitlesRequestStatusByVideoFileId: ImmutableMap(),
  locallyLoadedSubtitles: ImmutableMap()
};
export const defaultSubtitlesState = fromJS(defaultState);